import { SideNavBar, NotFound } from 'Components'
import styled from 'styled-components'
import Colors from 'Theme/Colors'
import Styles from './DefaultRouter.module.css'
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from 'react-router-dom'
import {
  AdminPage,
  UserPage,
  TransactionsPage,
  VouchersPage,
  AdminProfile,
  DashboardPage,
  CountriesPage,
  NotificationsPage,
  ChargingTokenPage,
} from 'Containers'
import { connect } from 'react-redux'
import AuthSelectors from 'Stores/Auth/Selectors'
import AuthActions from 'Stores/Auth/Actions'
import { changeRsuiteColors } from 'Theme'
import { useEffect } from 'react'
import RequestState from 'Enums/RequestState'
import { Actions, Subjects } from 'Enums/permissionKeys'

const PageContainer = styled.div`
  background-color: ${Colors.UserPageBackgroundColor};
`

const DefaultRouter = ({
  editingAdminRole,
  fetchEditingAdminRole,
  fetchAdminDetails,
  fetchEditingAdminRoleRequestState,
}) => {
  useEffect(() => {
    fetchEditingAdminRole()
    fetchAdminDetails()
  }, [])
  changeRsuiteColors(Colors.primary)
  const location = useLocation()
  const rowData = location.state?.rowData

  const hasAnyPermission =
    editingAdminRole?.can(Actions.VIEW, Subjects.USERS) ||
    editingAdminRole?.can(Actions.VIEW, Subjects.ADMINS) ||
    editingAdminRole?.can(Actions.VIEW, Subjects.NOTIFICATIONS) ||
    editingAdminRole?.can(Actions.VIEW, Subjects.NOTIFICATION_GROUPS) ||
    editingAdminRole?.can(Actions.VIEW, Subjects.TRANSACTIONS) ||
    editingAdminRole?.can(Actions.VIEW, Subjects.VOUCHERS) ||
    editingAdminRole?.can(Actions.VIEW, Subjects.DASHBOARD) ||
    editingAdminRole?.can(Actions.VIEW, Subjects.COUNTRIES) ||
    editingAdminRole?.can(Actions.VIEW, Subjects.CHARGING_TOKENS) ||
    editingAdminRole?.can(Actions.VIEW, Subjects.CHARGING_TOKENS_DESIGN)

  const navigate = useNavigate()
  useEffect(() => {
    if (
      fetchEditingAdminRoleRequestState === RequestState.SUCCEEDED &&
      !hasAnyPermission
    ) {
      navigate('/adminProfile')
    }
  }, [fetchEditingAdminRoleRequestState, hasAnyPermission, navigate])
  return (
    <PageContainer className={Styles.PageContainer}>
      {rowData ? <></> : <SideNavBar />}
      <div className={Styles.RightColumnContainer}>
        <div className={Styles.ContentContainer}>
          <Routes>
            <Route path="/login" element={<Navigate to="/" />} />
            <Route
              path="/"
              element={
                editingAdminRole?.can(Actions.VIEW, Subjects.USERS) ? (
                  <Navigate to="/user" />
                ) : editingAdminRole?.can(Actions.VIEW, Subjects.ADMINS) ? (
                  <Navigate to="/admin" />
                ) : editingAdminRole?.can(
                    Actions.VIEW,
                    Subjects.NOTIFICATIONS,
                  ) ||
                  editingAdminRole?.can(
                    Actions.VIEW,
                    Subjects.NOTIFICATION_GROUPS,
                  ) ? (
                  <Navigate to="/pushNotifications" />
                ) : editingAdminRole?.can(
                    Actions.VIEW,
                    Subjects.TRANSACTIONS,
                  ) ? (
                  <Navigate to="/transactions" />
                ) : editingAdminRole?.can(Actions.VIEW, Subjects.VOUCHERS) ? (
                  <Navigate to="/vouchers" />
                ) : editingAdminRole?.can(Actions.VIEW, Subjects.DASHBOARD) ? (
                  <Navigate to="/analytics" />
                ) : editingAdminRole?.can(Actions.VIEW, Subjects.COUNTRIES) ? (
                  <Navigate to="/countries" />
                ) : editingAdminRole?.can(
                    Actions.VIEW,
                    Subjects.CHARGING_TOKENS,
                  ) ||
                  editingAdminRole?.can(
                    Actions.VIEW,
                    Subjects.CHARGING_TOKENS_DESIGN,
                  ) ? (
                  <Navigate to="/chargingTokens" />
                ) : (
                  fetchEditingAdminRoleRequestState ===
                    RequestState.SUCCEEDED && <Navigate to="/NotFound" />
                )
              }
            />
            <Route
              path="/admin"
              element={
                editingAdminRole?.can(Actions.VIEW, Subjects.ADMINS) ? (
                  <AdminPage />
                ) : (
                  fetchEditingAdminRoleRequestState ===
                    RequestState.SUCCEEDED && <Navigate to="/NotFound" />
                )
              }
            />
            <Route
              path="/user/:id"
              element={
                editingAdminRole?.can(Actions.VIEW, Subjects.USERS) ? (
                  <UserPage />
                ) : (
                  fetchEditingAdminRoleRequestState ===
                    RequestState.SUCCEEDED && <Navigate to="/NotFound" />
                )
              }
            />
            <Route
              path="/user/"
              element={
                editingAdminRole?.can(Actions.VIEW, Subjects.USERS) ? (
                  <UserPage />
                ) : (
                  fetchEditingAdminRoleRequestState ===
                    RequestState.SUCCEEDED && <Navigate to="/NotFound" />
                )
              }
            />
            <Route
              path="/pushNotifications"
              element={
                editingAdminRole?.can(Actions.VIEW, Subjects.NOTIFICATIONS) ||
                editingAdminRole?.can(
                  Actions.VIEW,
                  Subjects.NOTIFICATION_GROUPS,
                ) ? (
                  <NotificationsPage />
                ) : (
                  fetchEditingAdminRoleRequestState ===
                    RequestState.SUCCEEDED && <Navigate to="/NotFound" />
                )
              }
            />
            <Route
              path="/transactions"
              element={
                editingAdminRole?.can(Actions.VIEW, Subjects.TRANSACTIONS) ? (
                  <TransactionsPage />
                ) : (
                  fetchEditingAdminRoleRequestState ===
                    RequestState.SUCCEEDED && <Navigate to="/NotFound" />
                )
              }
            />
            <Route
              path="/vouchers"
              element={
                editingAdminRole?.can(Actions.VIEW, Subjects.VOUCHERS) ? (
                  <VouchersPage />
                ) : (
                  fetchEditingAdminRoleRequestState ===
                    RequestState.SUCCEEDED && <Navigate to="/NotFound" />
                )
              }
            />
            <Route
              path="/analytics"
              element={
                editingAdminRole?.can(Actions.VIEW, Subjects.DASHBOARD) ? (
                  <DashboardPage />
                ) : (
                  fetchEditingAdminRoleRequestState ===
                    RequestState.SUCCEEDED && <Navigate to="/NotFound" />
                )
              }
            />
            <Route path="/adminProfile" element={<AdminProfile />} />
            <Route
              path="/countries"
              element={
                editingAdminRole?.can(Actions.VIEW, Subjects.COUNTRIES) ? (
                  <CountriesPage />
                ) : (
                  fetchEditingAdminRoleRequestState ===
                    RequestState.SUCCEEDED && <Navigate to="/NotFound" />
                )
              }
            />
            <Route
              path="/chargingTokens"
              element={
                editingAdminRole?.can(Actions.VIEW, Subjects.CHARGING_TOKENS) ||
                editingAdminRole?.can(
                  Actions.VIEW,
                  Subjects.CHARGING_TOKENS_DESIGN,
                ) ? (
                  <ChargingTokenPage />
                ) : (
                  fetchEditingAdminRoleRequestState ===
                    RequestState.SUCCEEDED && <Navigate to="/NotFound" />
                )
              }
            />
            <Route
              path="*"
              element={
                fetchEditingAdminRoleRequestState === RequestState.SUCCEEDED &&
                !hasAnyPermission ? (
                  <AdminProfile />
                ) : (
                  <NotFound />
                )
              }
            />
          </Routes>
        </div>
      </div>
    </PageContainer>
  )
}

const mapStateToProps = (state) => ({
  editingAdminRole: AuthSelectors.getEditingAdminRole(state),
  fetchEditingAdminRoleRequestState:
    AuthSelectors.getFetchEditingAdminRoleRequestState(state),
})

function mapDispatchToProps(dispatch) {
  return {
    logout: () => dispatch(AuthActions.logout()),
    fetchEditingAdminRole: () => dispatch(AuthActions.fetchEditingAdminRole()),
    fetchAdminDetails: () => dispatch(AuthActions.fetchAdminDetails()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultRouter)
